class ShippingCaculator extends HTMLElement {
  constructor() {
    super();
    this.needEndLoading = false;
    this.showingErrors = false;
    this.generatedShipping = 0;
    this.button = null;
    this.addressCountrySelect = null;
    this.addressProvinceSelect = null;
    this.addressZipInput = null;
    this.resultsTag = null;
    this.resultsList = null;
    this.resultsErrorHeading = null;
    this.resultsSuccessHeading = null;
    this.onCartChangeHandler = this.onCartChange.bind(this);
    this.zipOnly = false;
  }

  connectedCallback() {
    this.zipOnly = this.dataset.zipOnly === "true";
    // Inicializa refs ao conectar (filhos já estão no DOM) - evita erro no minicart/drawer
    this.button = this.querySelector("button");
    this.addressCountrySelect = this.querySelector("#AddressCountryCalculator");
    this.addressProvinceSelect = this.querySelector(
      "#AddressProvinceCalculator"
    );
    this.addressZipInput = this.querySelector("#AddressZipCalculator");
    this.resultsTag = this.querySelector(".shipping-calculator__results");
    this.resultsList = this.querySelector(".shipping-calculator__results-list");
    this.resultsErrorHeading = this.querySelector(
      ".shipping-calculator__error-heading"
    );
    this.resultsSuccessHeading = this.querySelector(
      ".shipping-calculator__success-heading"
    );

    if (
      !this.button ||
      !this.addressZipInput ||
      !this.resultsTag ||
      !this.resultsList
    )
      return;

    this.button.addEventListener("click", this.onButtonClick.bind(this));
    if (this.zipOnly && this.addressZipInput) {
      this.addressZipInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          this.button.click();
        }
      });
    }
    this.addEventListener("change", this.hideErrorsTag.bind(this), false);
    document.addEventListener("afterCartChanged", this.onCartChangeHandler);
    document.addEventListener("afterUpdateQuantity", this.onCartChangeHandler);

    this.setupCountries();
  }

  disconnectedCallback() {
    document.removeEventListener("afterCartChanged", this.onCartChangeHandler);
    document.removeEventListener(
      "afterUpdateQuantity",
      this.onCartChangeHandler
    );
  }

  setupCountries() {
    if (!this.addressCountrySelect) return;
    const countryValue = this.addressCountrySelect.value;
    if (!countryValue || countryValue === "---" || countryValue === "") {
      this.addressCountrySelect.value = "Brazil";
    }
  }

  onCartChange() {
    if (window.pdpCalculatingShipping) return;
    if (this.resultsTag) this.resultsTag.classList.add("hidden");
  }

  serialize(obj, prefix) {
    var str = [],
      p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push(
          v !== null && typeof v === "object"
            ? this.serialize(v, k)
            : encodeURIComponent(k) + "=" + encodeURIComponent(v)
        );
      }
    }
    return str.join("&");
  }

  /**
   * Parseia o body da Response como JSON sem lançar quando o body está vazio.
   * Evita "Unexpected end of JSON input" / "Failed to execute 'json' on 'Response'".
   */
  safeResponseJson(response) {
    return response.text().then((text) => {
      const trimmed = (text || "").trim();
      if (!trimmed) return null;
      try {
        return JSON.parse(trimmed);
      } catch (e) {
        throw e;
      }
    });
  }

  startLoading() {
    if (!this.button) return;
    this.needEndLoading = true;
    this.button.setAttribute("aria-disabled", true);
    this.button.classList.add("loading");
    const spinner = this.querySelector(".loading-overlay__spinner");
    const submitIcon = this.querySelector(
      ".cart-drawer-secondary__shipping-submit-icon"
    );
    if (spinner) spinner.classList.remove("hidden");
    if (submitIcon) submitIcon.classList.add("hidden");
  }

  endLoading() {
    if (!this.needEndLoading) return;
    this.needEndLoading = false;
    if (this.button) {
      this.button.setAttribute("aria-disabled", false);
      this.button.classList.remove("loading");
    }
    const spinner = this.querySelector(".loading-overlay__spinner");
    const submitIcon = this.querySelector(
      ".cart-drawer-secondary__shipping-submit-icon"
    );
    if (spinner) spinner.classList.add("hidden");
    if (submitIcon) submitIcon.classList.remove("hidden");
  }

  appendResultNode(text) {
    if (!this.resultsList) return;
    const li = document.createElement("li");
    const node = document.createTextNode(text);
    li.appendChild(node);
    this.resultsList.appendChild(li);
  }

  handleResultsList(list) {
    if (!this.resultsList || !this.resultsTag) return;
    this.resultsList.innerHTML = "";
    for (var key in list) {
      if (Array.isArray(list[key])) {
        list[key].forEach((item) => {
          if (typeof item === "object") {
            const li = document.createElement("li");
            const spanPrice = document.createElement("span");
            spanPrice.classList.add("price");
            const span = document.createElement("span");
            span.classList.add("cart-item__price", "heading-font");
            const text = item.presentment_name + ": ";
            span.innerHTML = Shopify.showPrice(item.price * 100);
            spanPrice.append(span);
            const node = document.createTextNode(text);
            li.appendChild(node);
            li.appendChild(spanPrice);
            if (item.delivery_days.length > 0) {
              const spanDate = document.createElement("span");
              spanDate.classList.add("caption", "shipping-calculator__date");
              var spanDateText = "( ";
              if (item.delivery_days[0] == item.delivery_days[1]) {
                if (parseInt(item.delivery_days[0]) <= 1) {
                  spanDateText += this.dataset.deliveryDateOne.replace(
                    "[count]",
                    item.delivery_days[0]
                  );
                } else {
                  spanDateText += this.dataset.deliveryDateMany.replace(
                    "[count]",
                    item.delivery_days[0]
                  );
                }
              } else {
                spanDateText +=
                  this.dataset.deliveryDateRange.replace(
                    "[minimum]",
                    item.delivery_days[0]
                  ) +
                  this.dataset.deliveryDateRange.replace(
                    "[maximum]",
                    item.delivery_days[1]
                  );
              }
              spanDateText += " )";
              const nodeSpanDateText = document.createTextNode(spanDateText);
              spanDate.appendChild(nodeSpanDateText);
              li.appendChild(spanDate);
            }
            this.resultsList.appendChild(li);
          } else {
            this.appendResultNode(item);
          }
        });
      } else {
        this.appendResultNode(list[key]);
      }
    }
    this.resultsTag.classList.remove("hidden");
  }

  handleErrorResponse(errors) {
    if (window.pdpCalculatingShipping) return;
    this.generatedShipping = 0;
    this.showingErrors = true;
    if (this.resultsErrorHeading)
      this.resultsErrorHeading.classList.remove("hidden");
    if (this.resultsSuccessHeading)
      this.resultsSuccessHeading.classList.add("hidden");
    this.handleResultsList(errors);
  }

  handleSuccessResponse(list) {
    this.generatedShipping = 0;
    this.showingErrors = false;
    if (this.resultsSuccessHeading)
      this.resultsSuccessHeading.classList.remove("hidden");
    if (this.resultsErrorHeading)
      this.resultsErrorHeading.classList.add("hidden");
    this.handleResultsList(list);
  }

  hideErrorsTag() {
    if (this.showingErrors && this.resultsTag) {
      this.resultsTag.classList.add("hidden");
      this.showingErrors = false;
    }
  }

  fetchWithTimeout(url, timeout = 5000) {
    return Promise.race([
      fetch(url),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Timeout")), timeout)
      ),
    ]);
  }

  /**
   * Busca UF e cidade pelo CEP via ViaCEP (https://viacep.com.br/)
   */
  async fetchAddressFromViaCep(zipValue) {
    const response = await this.fetchWithTimeout(
      `https://viacep.com.br/ws/${zipValue}/json/`,
      5000
    );

    if (response.status === 400) {
      throw new Error("CEP_INVALID");
    }

    const data = await response.json();

    if (data.erro) {
      throw new Error("CEP_NOT_FOUND");
    }

    if (!data.uf) {
      throw new Error("CEP_INCOMPLETE");
    }

    return data;
  }

  async resolveProvinceFromZip(zipValue) {
    const viaCepData = await this.fetchAddressFromViaCep(zipValue);

    if (this.addressProvinceSelect) {
      this.addressProvinceSelect.value = viaCepData.uf;
    }

    return viaCepData.uf;
  }

  getCepLookupErrorMessage(error) {
    if (error.message === "CEP_INVALID") {
      return { zip: ["Digite um CEP válido com 8 dígitos."] };
    }
    if (error.message === "CEP_NOT_FOUND") {
      return { zip: ["CEP não encontrado. Verifique e tente novamente."] };
    }
    if (error.message === "CEP_INCOMPLETE" || error.message === "CEP_LOOKUP_FAILED") {
      return {
        zip: ["Não foi possível obter o endereço pelo CEP. Tente novamente."],
      };
    }
    if (error.message === "Timeout") {
      return { zip: ["Tempo esgotado ao consultar o CEP. Tente novamente."] };
    }
    return {
      zip: ["Não foi possível validar o CEP. Verifique se está correto."],
    };
  }

  async onButtonClick(event) {
    const routes = window.routes;
    if (!routes || typeof fetchConfig !== "function") {
      this.handleErrorResponse({
        erro: ["Configuração do tema não carregada. Recarregue a página."],
      });
      return;
    }
    if (!this.button || !this.addressZipInput) return;
    if (this.button.classList.contains("loading")) return;

    if (window.pdpCalculatingShipping) {
      alert("Aguarde o cálculo de frete da página de produto finalizar.");
      return;
    }

    const zipValue = this.addressZipInput.value.replace(/\D/g, "");
    if (!zipValue || zipValue.length !== 8) {
      this.handleErrorResponse({
        zip: ["Por favor, digite um CEP válido com 8 dígitos"],
      });
      return;
    }

    // Verifica se o carrinho tem itens
    try {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      if (!cartData.items || cartData.items.length === 0) {
        this.handleErrorResponse({
          cart: ["Adicione produtos ao carrinho antes de calcular o frete"],
        });
        return;
      }
    } catch (e) {}

    this.startLoading();

    let provinceValue;

    try {
      provinceValue = await this.resolveProvinceFromZip(zipValue);
    } catch (error) {
      this.handleErrorResponse(this.getCepLookupErrorMessage(error));
      this.endLoading();
      return;
    }

    if (!provinceValue) {
      this.endLoading();
      return;
    }

    if (!provinceValue || provinceValue === "") {
      this.handleErrorResponse({
        zip: ["Não foi possível determinar o estado pelo CEP."],
      });
      this.endLoading();
      return;
    }

    let countryValue = "Brazil";
    if (this.addressCountrySelect) {
      countryValue = this.addressCountrySelect.value;
      if (!countryValue || countryValue === "---" || countryValue === "") {
        countryValue = "Brazil";
        this.addressCountrySelect.value = "Brazil";
      }
    }

    const params = {
      shipping_address: {
        country: countryValue,
        province: provinceValue,
        zip: zipValue,
      },
    };

    const body = JSON.stringify(params);
    fetch(`${routes.cart_url}/prepare_shipping_rates.json`, {
      ...fetchConfig("json", "POST"),
      ...{ body },
    })
      .then((response) => {
        // Se for erro 422, trata antes de parsear JSON
        if (response.status === 422) {
          return this.safeResponseJson(response).then(() => {
            throw new Error("Carrinho vazio ou dados inválidos");
          });
        }

        // 202 Accepted = Shopify aceitou e vai calcular em background; body vazio é normal
        if (response.status === 202) {
          return Promise.resolve({ ok: true });
        }

        return this.safeResponseJson(response);
      })
      .then((response) => {
        // Verifica novamente se PDP não começou a calcular durante a requisição
        if (window.pdpCalculatingShipping) {
          this.endLoading();
          return;
        }

        // Resposta vazia ou inválida do prepare_shipping_rates
        if (response === null) {
          this.needEndLoading = true;
          this.handleErrorResponse({
            erro: ["O servidor não respondeu. Tente novamente em instantes."],
          });
          return;
        }

        if (response == null || response.ok) {
          fetch(
            `${routes.cart_url}/async_shipping_rates.json?` +
              this.serialize(params),
            { ...fetchConfig("json", "GET"), ...{} }
          )
            .then((finalResponse) => this.safeResponseJson(finalResponse))
            .then((finalResponse) => {
              if (finalResponse != null) {
                this.needEndLoading = true;
                this.handleSuccessResponse(finalResponse);
              } else if (this.generatedShipping < 10) {
                // Resposta vazia = Shopify ainda calculando; tenta de novo após 2.3s (até 10x)
                this.needEndLoading = false;
                setTimeout(() => {
                  this.needEndLoading = true;
                  this.endLoading();
                  this.generatedShipping++;
                  if (this.button)
                    this.button.dispatchEvent(new MouseEvent("click"));
                }, 2300);
              } else {
                this.needEndLoading = true;
                this.handleErrorResponse({
                  erro: [
                    "Não foi possível obter as opções de frete. Tente novamente.",
                  ],
                });
              }
            })
            .finally(() => {
              this.endLoading();
            });
        } else {
          this.needEndLoading = true;
          this.handleErrorResponse(response);
        }
      })
      .catch((e) => {
        // Só mostra erro se não for conflito com PDP
        if (!window.pdpCalculatingShipping) {
          if (e.message.includes("Carrinho vazio")) {
            this.handleErrorResponse({
              cart: ["Adicione produtos ao carrinho antes de calcular o frete"],
            });
          } else {
            this.handleErrorResponse({
              erro: [
                "Não foi possível calcular o frete. Verifique o CEP e tente novamente.",
              ],
            });
          }
        }
        this.needEndLoading = true;
      })
      .finally(() => {
        this.endLoading();
      });
  }
}

customElements.define("shipping-calculator", ShippingCaculator);
